<img 
    src='/images/logos/LogoWhite.png' 
    class='img-fluid mx-auto' 
    alt='THEXA'
/>